<template>
  <div class="container">
    <div class="options">
      <a-space>
        <a-button type="primary" icon="plus" @click="handleAdd"
          >添加科目</a-button>

        <a-upload name="file" :showUploadList="false" :custom-request="(e) => handleUpload(e)" accept=".xlsx" >
          <a-button type="primary">
            <a-icon type="upload"/> 上传文件
          </a-button>
        </a-upload>
      </a-space>
    </div>


    <a-table
      :columns="columns"
      :data-source="data"
      :row-selection="rowSelection"
      :loading="loading"
      :pagination="{ current: current, pageSize: pageSize, total: total }"
      @change="handleTableChange"
    >
      <a
        slot="realname"
        slot-scope="realname, record"
        @click="handleShow(record)"
      >
        {{ realname }}
      </a>
      <span slot="agentRole" slot-scope="agentRole">
        {{
          roleList.filter((item) => item.id == agentRole)[0]
            ? roleList.filter((item) => item.id == agentRole)[0].name
            : "-"
        }}
      </span>
      <span slot="status" slot-scope="status">
        <a-tag :key="status" :color="status == '1' ? 'green' : 'red'">
          {{ statusFormatter(status) }}
        </a-tag>
      </span>
      <span slot="createTime" slot-scope="createTime">
        {{ $moment(createTime).format("YYYY-MM-DD") }}
      </span>
      <span slot="action" slot-scope="text, record">
        <a @click="handleEdit(record)">编辑</a>
        <a-divider type="vertical" />
        <a @click="handleDelete(record.id)">禁用</a>
      </span>
    </a-table>
    <subject-modal ref="subjectModal" @reload="queryList" />
  </div>
</template>
<script>
import subjectModal from "./components/subjectModal";
import {
  querySubjectList,
  deleteSubject,
  excelImport,
} from "@/api/subject";
export default {
  name: "user",
  data() {
    return {
      loading: false,
      data: [],
      columns: [
        {
          title: "ID",
          dataIndex: "id",
          key: "id",
        },
        {
          title: "科目编码",
          dataIndex: "subNo",
          key: "subNo",
        },
        {
          title: "科目名称",
          dataIndex: "subName",
          key: "subName",
        },
        {
          title: "科目类型",
          dataIndex: "subType",
          key: "subType",
        },
        {
          title: "科目范围",
          dataIndex: "subArea",
          key: "subArea",
        },
        // {
        //   title: "税务科目编码",
        //   dataIndex: "taxDecNo",
        //   key: "taxDecNo",
        // },
        // {
        //   title: "税务科目名称",
        //   dataIndex: "taxSubName",
        //   key: "taxSubName",
        // },
        // {
        //   title: "年度余额取值",
        //   dataIndex: "yearCol",
        //   key: "yearCol",
        // },
        // {
        //   title: "季度余额取值",
        //   dataIndex: "quarCol",
        //   key: "quarCol",
        // },
        // {
        //   title: "月度余额取值",
        //   dataIndex: "monthCol",
        //   key: "monthCol",
        // },
        {
          title: "操作",
          key: "action",
          align: "center",
          scopedSlots: { customRender: "action" },
        },
      ],
      current: 1,
      pageSize: 10,
      total: 0,
      roleList: [],
      selectedRowKeys: [],
      selectedRows: [],
    };
  },
  components: { subjectModal},
  async created() {
    await this.queryList();
  },
  methods: {
    statusFormatter(status) {
      if (status == 1) {
        return "启用";
      } else {
        return "禁用";
      }
    },
    async queryList() {
      this.loading = true;
      let res = await querySubjectList({
        page: this.current,
        pageSize: this.pageSize,
      });
      if (res.status == 200) {
        this.data = res.data.rows;
        this.total = res.data.records;
      } else {
        let msg = res.msg || res.message;
        let len = msg.length;
        this.$notification.error({
          message: "系统提示",
          description: len > 100 ? "系统错误，请联系管理员" : msg,
          duration: 4,
        });
      }
      this.loading = false;
    },
    handleDelete(id) {
      const that = this;
      this.$confirm({
        title: "确认删除",
        content: "是否删除当前数据?",
        onOk: async function () {
          let res = await deleteSubject({ id: id });
          if (res.status == 200) {
            that.$message.success("删除成功");
            that.queryList();
          } else {
            that.$notification.error({
              message: "系统提示",
              description: res.msg || res.message,
              duration: 4,
            });
          }
        },
      });
    },
    handleShow(record) {
      this.$refs.subjectModal.show(1, record);
    },
    handleAdd() {
      this.$refs.subjectModal.show(2);
    },
    handleEdit(record) {
      this.$refs.subjectModal.show(3, record);
    },

    async handleUpload(file) {
      debugger;
      let fileName = file.file.name;
      let formData = new FormData();
      formData.append("file", file.file, fileName);

      let res = await excelImport(formData);
      if (res=="") {
        this.$message.success("标准科目上传成功！");
        this.getUploadStatus();
      } else {
        let msg = res.msg || res.message;
        let len = msg.length;
        this.$notification.error({
          message: "系统提示",
          description: len > 100 ? "系统错误，请联系管理员" : msg,
          duration: 4,
        });
      }
    },

    handleTableChange(pagination) {
      this.current = pagination.current;
      this.pageSize = pagination.pageSize;
      this.total = pagination.total;
      this.queryList();
    },
    handleUpdatePsd() {
      if (this.selectedRows.length != 1) {
        return this.$message.warning("请选择一条数据！");
      }
      this.$refs.passwordModal.show(this.selectedRows[0].email);
    },
  },
  computed: {
    rowSelection() {
      return {
        selectedRowKeys: this.selectedRowKeys,
        onChange: (selectedRowKeys, selectedRows) => {
          this.selectedRowKeys = selectedRowKeys;
          this.selectedRows = selectedRows;
        },
      };
    },
  },
};
</script>
<style lang="less" scoped>
/deep/ .ant-tag {
  margin: 0;
}
.container {
  padding: 20px;
  background: #fff;
  min-height: 280px;
}
.options {
  padding-bottom: 16px;
}
</style>
